<template>
  <div class="container">
    <img v-bind:class="{ selected: !checked }" class="logo" :src="getImageLink" />
    <label class="switch">
      <input type="checkbox" v-model="checked" />
      <span class="slider round"></span>
    </label>
    <span v-bind:class="{ selected: checked }" class="text">Verre sans protection</span>
  </div>
</template>

<script>
export default {
  props: ['text', 'image'],
  data() {
    return {
      checked: true,
    };
  },
  methods: {},
  watch: {
    checked: function() {
      this.$emit('valueCheck', this.checked);
    },
  },
  computed: {
    getImageLink() {
      return require('../../../assets/logo-marque/' + this.image);
    },
  },
};
</script>
<style scoped>
.container {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
}

.logo {
  width: 100px;
  height: 100px;
  opacity: 0.5;
}

.switch {
  position: relative;
  display: inline-block;
  width: 65px;
  height: 34px;
}

.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.text {
  color: black;
  font-weight: bolder;
  margin: 9px;
  opacity: 0.5;
}

.selected {
  opacity: 1;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: white;
  -webkit-transition: 0.4s;
  transition: 0.4s;
  border: 0.7px solid #ccc;
}

.slider:before {
  position: absolute;
  content: '';
  height: 22px;
  width: 22px;
  left: 6px;
  bottom: 5px;
  background-color: #0088ec;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

input:checked + .slider:before {
  background-color: black;
  -webkit-transform: translateX(30px);
  -ms-transform: translateX(30px);
  transform: translateX(30px);
}

/* Rounded sliders */
.slider.round {
  border-radius: 20px;
}

.slider.round:before {
  border-radius: 50%;
}
</style>
